export enum ErrorCode {
  INVALID_API_KEY = "INVALID_API_KEY",
  INVALID_SIGNATURE = "INVALID_SIGNATURE",
  RESOURCE_NOT_FOUND = "RESOURCE_NOT_FOUND",
  TOO_MANY_REQUESTS = "TOO_MANY_REQUESTS",
  ALREADY_EXISTS = "ALREADY_EXISTS",
  UNAUTHORIZED = "UNAUTHORIZED",
  FORBIDDEN = "FORBIDDEN",
  CONTRACT_NOT_STARTED = "CONTRACT_NOT_STARTED",
  CONTRACT_EXPIRED = "CONTRACT_EXPIRED",
  PASSWORD_EXPIRED = "PASSWORD_EXPIRED",
  IP_RESTRICTED = "IP_RESTRICTED",
  IP_ACCESS_DENIED = "IP_ACCESS_DENIED",
}
